<wm-workflow-previous-system-list
  [id]="id"
  [clientId]="clientId"
></wm-workflow-previous-system-list>
